<template>
  <q-header class="the-titlebar">
    <q-toolbar class="the-titlebar__toolbar" data-nosnippet>
      <q-btn
        v-if="enableMobileDisplay"
        flat
        round
        dense
        :ripple="false"
        icon="sym_r_menu"
        style="position: absolute; left: 0; top: -2px; font-size: 22px;"
        @click="
          () => {
            promptTheMenuDialog();
          }
        "
        data-nosnippet
      />

      <AppLogo color="#fff" data-nosnippet class="q-ml-sm" height="18" />

      <SearchInputBar v-if="!enableMobileDisplay" class="q-mx-lg" />

      <div
        v-if="!enableMobileDisplay"
        class="flex items-center q-gutter-x-lg col-auto"
      >
        <!--<a href="javascript:void(0)" @click="promptListInventoryDialog"
          >List Inventory</a
        >-->

        <a href="javascript:void(0)" @click="promptContactDialog">Get Help</a>

        <!--<q-btn
          round
          no-caps
          class="--bordered"
          style="margin-top: -2px"
          icon="sym_r_account_circle"
        />-->
      </div>
    </q-toolbar>
  </q-header>
</template>

<script>
import AppLogo from "@/components/AppLogo";
import SearchInputBar from "@/components/SearchInputBar.vue";
import ContactDialog from "@/components/ContactDialog.vue";
import { Dialog } from "quasar";
import ListInventoryDialog from "@/components/ListInventoryDialog.vue";
import TheMenuDialog from "@/components/TheMenuDialog.vue";

export default {
  name: "TheTitlebar",
  components: {
    SearchInputBar,
    AppLogo
  },
  data() {
    return {};
  },
  methods: {
    promptContactDialog() {
      Dialog.create({
        component: ContactDialog
      });
    },
    promptListInventoryDialog() {
      Dialog.create({
        component: ListInventoryDialog
      });
    },
    promptTheMenuDialog() {
      Dialog.create({
        component: TheMenuDialog
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.the-titlebar {
  height: 66px;
  background: color(background, light);
  padding: $space-sm;
  // border-top: 1px solid color(border);
  // border-right: 1px solid color(border);
  border-bottom: 1px solid color(border);
  border-color: color(border) !important;
  box-shadow: $shadow-bottom;
  white-space: nowrap;
  z-index: 100;

  .the-titlebar__toolbar {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include screen-sm {
      justify-content: center;
    }
  }
}
</style>
